var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import { EventEmitter } from 'events';
export var NotificationSeverity;
(function (NotificationSeverity) {
  NotificationSeverity[NotificationSeverity["INFO"] = 0] = "INFO";
  NotificationSeverity[NotificationSeverity["SUCCESS"] = 1] = "SUCCESS";
  NotificationSeverity[NotificationSeverity["ERROR"] = 2] = "ERROR";
})(NotificationSeverity || (NotificationSeverity = {}));
var NotificationService = /** @class */function (_super) {
  __extends(NotificationService, _super);
  function NotificationService() {
    var _this = _super.call(this) || this;
    _this.show = _this.show.bind(_this);
    _this.success = _this.success.bind(_this);
    return _this;
  }
  NotificationService.prototype.info = function (message) {
    this.show({
      message: message,
      severity: NotificationSeverity.INFO
    });
  };
  NotificationService.prototype.success = function (message) {
    this.show({
      message: message,
      severity: NotificationSeverity.SUCCESS
    });
  };
  NotificationService.prototype.error = function (message) {
    this.show({
      message: message,
      severity: NotificationSeverity.ERROR
    });
  };
  NotificationService.prototype.show = function (notification) {
    notification.severity = notification.severity || NotificationSeverity.INFO;
    switch (notification.severity) {
      case NotificationSeverity.SUCCESS:
        notification.severity = 1;
        break;
      case NotificationSeverity.ERROR:
        notification.severity = 2;
        break;
    }
    this.emit('show', notification);
  };
  return NotificationService;
}(EventEmitter);
export default new NotificationService();